export const ignoreLoader = {
    apis: [
        '/api/Products/checkPayment',
        'api/apps/getTerminalParams'
    ]
};